import { render, staticRenderFns } from "./AdminEbOptionsList.vue?vue&type=template&id=128478ee&scoped=true"
import script from "./AdminEbOptionsList.vue?vue&type=script&lang=js"
export * from "./AdminEbOptionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128478ee",
  null
  
)

export default component.exports